import React from "react";
import {
    DialogActions as DialogActionsContainer,
    makeStyles,
    Button,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    footer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 0,
    }
}));

export const DialogActions = ({ handleClose, handleSubmit, disabled, buttonText }) => {
    const classes = useStyles();

    return (
        <DialogActionsContainer className={classes.footer}>
            <Button onClick={handleClose} color="primary" variant="outlined">
                Fechar
            </Button>
            <Button onClick={handleSubmit} color="primary" variant="contained" disabled={disabled}>
                {buttonText}
            </Button>
        </DialogActionsContainer>
    );
};